import config from 'app/config'
import api from 'common/helpers/api'

export const toggleGarminCall = () => {
    const url = `${config.API_URL}/garmin/activation/`
    return api.post(url)
}